// Utilities.js
import { Utilities } from "./Utilities.js";

export const HTTPUtilities = {
  async post(app, route, data, successCallback, alert, customBaseUrl = null) {
    await app.$axios({
      method: "POST",
      url: route,
      data,
      baseURL: customBaseUrl || undefined,
      headers: { "Authorization": `bearer ${app.$Session.get(app.$userSessionName).token.Value}` }
    }).then(successCallback)
      .catch(error => this.handleError(error, alert));
  },

  async put(app, route, data, successCallback, alert, customBaseUrl = null) {
    await app.$axios({
      method: "PUT",
      url: route,
      data,
      baseURL: customBaseUrl || undefined,
      headers: { "Authorization": `bearer ${app.$Session.get(app.$userSessionName).token.Value}` }
    }).then(successCallback)
      .catch(error => this.handleError(error, alert));
  },

  async get(app, route, successCallback, alert, customBaseUrl = null) {
    await app.$axios({
      method: "GET",
      url: route,
      baseURL: customBaseUrl || undefined,
      headers: { "Authorization": `bearer ${app.$Session.get(app.$userSessionName).token.Value}` }
    }).then(successCallback)
      .catch(error => this.handleError(error, alert));
  },

  async delete(app, route, successCallback, alert, customBaseUrl = null) {
    await app.$axios({
      method: "DELETE",
      url: route,
      baseURL: customBaseUrl || undefined,
      headers: { "Authorization": `bearer ${app.$Session.get(app.$userSessionName).token.Value}` }
    }).then(successCallback)
      .catch(error => this.handleError(error, alert));
  },

  handleError(error, alert) {
    if (error.response) Utilities.verifyToken(error.response.status);

    if (alert) {
      alert.show = true;
      alert.type = "danger";

      if (!error.response) {
        alert.message = "Não foi possível conectar ao servidor.";
        console.error(error);
        return;
      }

      alert.message = (error.response.data && error.response.data.StatusCode == 400
        ? error.response.data.Message || "Erro interno."
        : "Erro interno.");
    }
  }
};

export default function (app) {
  return app.config.globalProperties.$HTTPUtilities = HTTPUtilities;
}
